import { GzSingleSelectComplexBaseDataProvider } from '../GzSingleSelectComplexBaseDataProvider';
import { ConsoleRequest, DataProviderType } from '../../../../utils/request';
import { GetItemsRequest, GetItemsResponse } from '../../types';

export class CompaniesForMdrContactDataProvider extends GzSingleSelectComplexBaseDataProvider {
  private _editedCompanyId?: string;

  async getItems({ searchValue, page, limit }: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    try {
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'Company',
        method: 'getMdrContactInfoAvailableCompanies',
        payload: {
          page,
          limit,
          filter: {
            targetOrParentId: this._editedCompanyId,
            name: searchValue,
          },
        },
      });

      return {
        items: response.data.map(({ _id, name }) => ({ value: _id, label: name })),
        totalItemsCount: response.total,
      };
    } catch (e) {
      throw new Error(e);
    }
  }

  async getInitialItems(request: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    try {
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'Company',
        method: 'getMdrContactInfoAvailableCompanies',
        payload: {
          page: request.page,
          limit: request.limit,
          filter: {
            targetOrParentId: this._editedCompanyId,
          },
        },
      });

      return {
        items: response.data.map(({ _id, name }) => ({ value: _id, label: name })),
        totalItemsCount: response.total,
      };
    } catch (e) {
      throw new Error(e);
    }
  }

  public set editedCompanyId(value: string | undefined) {
    this._editedCompanyId = value;
  }
}
